// export type NumericInput = number | `${number}`; // Allows only numeric strings

export class CalculatingHelper {
  static formatDivision = (dividend: string | number, divisor: string | number) => {
    if (!dividend || !divisor || divisor === '0') return '';

    // Convert both inputs to numbers and calculate
    const result = parseFloat(String(dividend)) / parseFloat(String(divisor));

    // Handle invalid numbers
    if (isNaN(result)) {
      return '';
    }

    // Round to 10 decimal places
    const roundedValue = Math.round(result * 1e10) / 1e10;

    // If the rounded value is 0, return '0'
    if (roundedValue === 0) {
      return '0';
    }

    // Convert to string with exactly 10 decimal places
    const decimalStr = roundedValue.toFixed(10);

    // If the number is very small (scientific notation territory)
    if (roundedValue < 0.000001) {
      // Convert to string and split into coefficient and exponent
      const parts = roundedValue.toString().split('e');
      if (parts.length === 2) {
        // Get the absolute value of the exponent
        const exponent = Math.abs(parseInt(parts[1]));
        // Create the decimal representation
        return '0.' + '0'.repeat(exponent - 1) + parts[0].replace('.', '');
      }
    }

    // Remove trailing zeros but maintain precision
    return decimalStr.replace(/\.?0+$/, '');
  };
}
